import React, { useState, useEffect } from 'react';

const InsertTextSection = ({ id, removeSection, onSave, initialValue = '' }) => {
    const [text, setText] = useState(initialValue);

    // Automatically save the text whenever it changes
    useEffect(() => {
        onSave({ id, type: 'text', value: text });
    }, [text, id, onSave]);

    return (
        <div className="card position-relative">
            <button type="button" className="close position-absolute" style={{ right: '10px', top: '10px', zIndex: 1 }} onClick={() => removeSection(id)}>&times;</button>
            <div className="body" style={{ paddingTop: '40px' }}>
                <div className="form-group">
                    <textarea
                        className="form-control"
                        rows="10"
                        placeholder="Enter Blog Content"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        style={{
                            whiteSpace: 'pre',
                            overflowX: 'auto',
                            overflowWrap: 'normal',
                            fontFamily: 'monospace'
                        }}
                        wrap="off"
                    />
                </div>
            </div>
        </div>
    );
};

export default InsertTextSection;
